import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { ModalService, SidebarService } from "@ibe/services/ui";
import { INDRADropdownService } from "@ibe.services/dropdown.indra.service";
import { INDRALoginModalComponent } from "../login-modal/login-modal.indra.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-nlf-login-dropdown",
  templateUrl: "./nlf-login-dropdown.indra.component.html",
  styleUrls: ["./nlf-login-dropdown.component.scss"],
})
export class INDRANlfLoginDropdownComponent
  implements OnInit, OnDestroy
{
  dropdownSubscription: Subscription;
  constructor(
    private sidebarService: SidebarService,
    public dropdownService: INDRADropdownService,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    protected modalService: ModalService,
  ) {
  }

  ngOnInit() {
    this.dropdownSubscription = this.dropdownService.isOpen$.subscribe((isOpen) => {
      if (isOpen) {
        this.addBodyClass();
      } else {
        this.removeBodyClass();
      }
    });
  }

  closeDropdown(id: string): void {
    this.dropdownService.close(id);
    this.cd.detectChanges();
    this.dropdownSubscription.unsubscribe();
  }

  openLoginModal() {
    this.closeDropdown("loginDropdown");
    this.modalService.assignComponent(INDRALoginModalComponent);
    this.modalService.open();
  }

  openSidebar() {
    this.closeDropdown("loginDropdown");
    this.sidebarService.openSidebar(["sign-up"]);
  }

  addBodyClass() {
    this.renderer.addClass(document.documentElement, "hide-overflow--mobile");
  }

  removeBodyClass() {
    this.renderer.removeClass(
      document.documentElement,
      "hide-overflow--mobile",
    );
  }

  ngOnDestroy() {
    this.removeBodyClass();
    this.dropdownSubscription.unsubscribe();
  }
}
